















import Vue from 'vue';
import EntityPageDetailsList from '@/components/EntityPageDetailsList.vue';
import Rating from '@/components/Rating.vue';
import LocationPinIcon from '@/components/icons/LocationPinIcon';

export default Vue.extend({
  name: 'MallOverviewDetails',
  props: {
    description: String,
    address: String,
    rating: Number,
  },
  components: {
    EntityPageDetailsList,
    Rating,
    LocationPinIcon,
  },
});
